import { useState, useEffect, useRef } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import JobNewsSection from './JobNewsSection';
import RegisterChat from './Register';
import { SplitHeadline, Aurora, Spotlight, Magnetic, VideoShowcase, StickyCta, upgradeCss } from './HomeUpgrades';
import api from '../api/axios';
import PlanBExplainer from './PlanBExplainer';
   import HeroSection from './HeroSection';
   import landingData from '../seo/landingData';
   
/* ------------------------------- data ------------------------------- */
// import PlanBAnimatedHero from './PlanBAnimatedHero';

import imgSoftware from '../assets/software.jpg';
import imgDoctor from '../assets/doctor.jpg';
import imgBank from '../assets/bank.jpg';
import imgBpo from '../assets/bpo.jpg';
import imgManufacturing from '../assets/manufacturing.jpg';
import imgLogistics from '../assets/logistic.jpg';
import imgHotel from '../assets/hotel.jpg';
import imgTeacher from '../assets/teacher.jpg';
import imgHr from '../assets/HR.jpg';
import imgSales from '../assets/sales.jpg';
import imgMarketing from '../assets/marketing.jpg';
import imgConstruction from '../assets/constructour.jpg';

import imgBengaluru from '../assets/bengaluru.jpg';
import imgDelhi from '../assets/delhi.jpg';
import imgHyderabad from '../assets/hydrabad.jpg';
import imgKolkata from '../assets/kolkat.jpg';
import imgMumbai from '../assets/mumbi.jpg';

const FAQS = [
  { q: 'Is PlanB Jobs free for candidates?', a: 'Yes. Candidates can create a profile and explore opportunities for free.' },
  { q: 'Do I need work experience?', a: 'No. PlanB Jobs is for students, freshers and experienced professionals.' },
  { q: 'Can employers discover my profile?', a: 'Yes. Your profile can help employers discover candidates based on their skills, experience and career preferences.' },
  { q: 'Can I find internships?', a: 'Yes. Students and freshers can explore internship opportunities along with jobs.' },
  { q: 'Can I search jobs by location?', a: 'Yes. Candidates can search opportunities based on their preferred location.' },
  { q: 'Can colleges use PlanB Jobs?', a: 'Yes. Colleges can partner with PlanB Jobs for placements, internships, hiring drives and career initiatives.' },
];

// const QUICK_LINKS = [

//   { label: 'Work From Home Jobs', to: '/jobs?work_mode=work_from_home' },
//   { label: 'IT Jobs', to: '/jobs?department=software-development' },
//   { label: 'Healthcare Jobs', to: '/jobs?keyword=healthcare' },
//   { label: 'Sales Jobs', to: '/jobs?keyword=sales' },
//   { label: 'Marketing Jobs', to: '/jobs?keyword=marketing' },
//   { label: 'Finance Jobs', to: '/jobs?keyword=finance' },
//   { label: 'Part-Time Jobs', to: '/jobs?job_type=part_time' },
// ];

const WHY_FEATURES = [
  { icon: 'target', title: 'AI-Powered Job Discovery', body: 'Explore relevant opportunities based on your skills, experience and preferences.' },
  { icon: 'shield', title: 'Verified Employers', body: "Discover employers who have completed the platform's verification process." },
  { icon: 'briefcase', title: 'Opportunities Across Industries', body: 'Explore jobs in IT, healthcare, finance, sales, marketing, manufacturing, logistics, hospitality and more.' },
  { icon: 'cursor', title: 'Simple Applications', body: 'Create your profile and apply for relevant opportunities without unnecessary complications.' },
  { icon: 'cap', title: 'Career Opportunities for Everyone', body: "Whether you're a fresher or an experienced professional, your next opportunity starts here." },
];

// TODO: replace each `to` with your real SEO category page URL when those pages exist.
// const INDUSTRIES = [
//   { name: 'Information Technology', icon: 'cursor', to: '/jobs?department=software-development' },
//   { name: 'Healthcare & Hospitals', icon: 'shield', to: '/jobs?keyword=healthcare' },
//   { name: 'Banking & Finance', icon: 'building', to: '/jobs?keyword=finance' },
//   { name: 'Sales & Business Development', icon: 'target', to: '/jobs?keyword=sales' },
//   { name: 'Digital Marketing', icon: 'bolt', to: '/jobs?keyword=digital marketing' },
//   { name: 'BPO & Customer Support', icon: 'chat', to: '/jobs?keyword=customer support' },
//   { name: 'Manufacturing', icon: 'building', to: '/jobs?keyword=manufacturing' },
//   { name: 'Logistics & Supply Chain', icon: 'briefcase', to: '/jobs?keyword=logistics' },
//   { name: 'Hospitality & Retail', icon: 'clock', to: '/jobs?keyword=hospitality' },
//   { name: 'Education & Administration', icon: 'cap', to: '/jobs?keyword=education' },
//   { name: 'Construction & Engineering', icon: 'building', to: '/jobs?keyword=engineering' },
//   { name: 'Human Resources', icon: 'doc', to: '/jobs?keyword=human resources' },
// ];



const QUICK_LINKS = [
  { label: 'Work From Home Jobs', to: '/work-from-home-jobs' },
  { label: 'IT Jobs', to: '/jobs/it' },
  { label: 'Healthcare Jobs', to: '/jobs/healthcare' },
  { label: 'Sales Jobs', to: '/jobs/sales' },
  { label: 'Marketing Jobs', to: '/jobs/digital-marketing' },
  { label: 'Finance Jobs', to: '/jobs/banking-finance' },
  { label: 'Part-Time Jobs', to: '/part-time-jobs' },
];

const stock = (tags, seed) =>
  `https://picsum.photos/seed/planb${seed}/600/450`;

const INDUSTRIES = [
  { name: 'Information Technology', icon: 'cursor', to: '/jobs/it', image: imgSoftware },
  { name: 'Healthcare & Hospitals', icon: 'shield', to: '/jobs/healthcare', image: imgDoctor },
  { name: 'Banking & Finance', icon: 'building', to: '/jobs/banking-finance', image: imgBank },
  { name: 'Sales & Business Development', icon: 'target', to: '/jobs/sales', image: imgSales },
  { name: 'Digital Marketing', icon: 'bolt', to: '/jobs/digital-marketing', image: imgMarketing },
  { name: 'BPO & Customer Support', icon: 'chat', to: '/jobs/bpo', image: imgBpo },
  { name: 'Manufacturing', icon: 'building', to: '/jobs/manufacturing', image: imgManufacturing },
  { name: 'Logistics & Supply Chain', icon: 'briefcase', to: '/jobs/logistics', image: imgLogistics },
  { name: 'Hospitality & Retail', icon: 'clock', to: '/jobs/hospitality', image: imgHotel },
  { name: 'Education & Administration', icon: 'cap', to: '/jobs/education', image: imgTeacher },
  { name: 'Construction & Engineering', icon: 'building', to: '/jobs?keyword=engineering', image: imgConstruction },
  { name: 'Human Resources', icon: 'doc', to: '/jobs/hr-executive', image: imgHr },
];
const CAREER_STAGES = [
  { emoji: '🌱', who: 'Freshers', body: 'Your first job is a big step. Discover entry-level opportunities and start building your career.', cta: 'Explore Fresher Jobs', to: '/jobs?experience=fresher' },
  { emoji: '💼', who: 'Experienced Professionals', body: 'Ready for your next challenge? Find opportunities that match your skills and career experience.', cta: 'Explore Experienced Jobs', to: '/jobs' },
  { emoji: '🏠', who: 'Remote Job Seekers', body: 'Discover remote and hybrid opportunities that give you more flexibility.', cta: 'Explore Remote Jobs', to: '/jobs?work_mode=work_from_home' },
];

const AI_HIGHLIGHTS = [
  'Skill-based job matching',
  'Relevant job recommendations',
  'Candidate profile intelligence',
  'Smarter recruitment discovery',
];

const EMPLOYER_FEATURES = [
  'Simple job posting',
  'Candidate applications',
  'Employer dashboard',
  'Applicant management',
  'Recruitment analytics',
  'Affordable hiring packages',
];

const ICONS = {
  briefcase: <><rect x="2" y="7" width="20" height="13" rx="2" /><path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2M2 12h20" /></>,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  cap: <><path d="M2 9l10-5 10 5-10 5-10-5z" /><path d="M6 11v5c0 1.1 2.7 3 6 3s6-1.9 6-3v-5" /></>,
  doc: <><path d="M7 3h7l5 5v13a1 1 0 01-1 1H7a1 1 0 01-1-1V4a1 1 0 011-1z" /><path d="M14 3v5h5M9 13h6M9 17h6" /></>,
  building: <><rect x="4" y="3" width="10" height="18" /><rect x="14" y="9" width="6" height="12" /><path d="M7 7h1M11 7h1M7 11h1M11 11h1M7 15h1M11 15h1" /></>,
  target: <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1.2" fill="currentColor" /></>,
  bolt: <path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" />,
  cursor: <path d="M4 3l16 8-7 1.5L11 20 4 3z" />,
  chat: <path d="M21 11.5a8.4 8.4 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.4 8.4 0 01-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.4 8.4 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />,
  check: <path d="M20 6L9 17l-5-5" />,
  shield: <><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z" /><path d="M9 12l2 2 4-4" /></>,
  arrow: <path d="M5 12h14M13 6l6 6-6 6" />,
  pin: <><path d="M12 22s7-6.2 7-12a7 7 0 10-14 0c0 5.8 7 12 7 12z" /><circle cx="12" cy="10" r="2.5" /></>,
};

function Icon({ name }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-full h-full" aria-hidden="true">
      {ICONS[name]}
    </svg>
  );
}

function Reveal({ children, delay = 0, className = '', variant = 'up' }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (!('IntersectionObserver' in window)) { setShown(true); return; }
    const io = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setShown(true); io.disconnect(); } },
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={`reveal ${variant !== 'up' ? `reveal-${variant}` : ''} ${shown ? 'reveal-in' : ''} ${className}`}
    >
      {children}
    </div>
  );
}

function ScrollProgress() {
  const [p, setP] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      setP(h > 0 ? (window.scrollY / h) * 100 : 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className="fixed top-0 left-0 h-[3px] z-[100] brand-gradient" style={{ width: `${p}%` }} aria-hidden="true" />;
}

function RotatingWord({ words }) {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % words.length), 2200);
    return () => clearInterval(t);
  }, [words.length]);
  return <span key={i} className="swap inline-block font-bold text-[#DB2777]">{words[i]}</span>;
}

function TiltCard({ children, className = '', max = 8 }) {
  const ref = useRef(null);
  const reduce = typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  const onMove = (e) => {
    const el = ref.current;
    if (!el || reduce) return;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    el.style.transform = `perspective(900px) rotateX(${-y * max}deg) rotateY(${x * max}deg)`;
  };
  const reset = () => { if (ref.current) ref.current.style.transform = ''; };

  return (
    <div ref={ref} onMouseMove={onMove} onMouseLeave={reset} className={`tilt ${className}`}>
      {children}
    </div>
  );
}

/* ---------------------------- plan helpers ---------------------------- */
const fmtPrice = (n) => '₹' + Number(n || 0).toLocaleString('en-IN');

const planBullets = (p) => {
  const admin = Array.isArray(p.features) ? p.features.filter(Boolean) : [];
  if (admin.length) return admin.slice(0, 6);
  return [
    p.job_post_limit == null ? 'Unlimited active jobs' : `${p.job_post_limit} active jobs`,
    p.job_validity_days != null && `${p.job_validity_days} days job validity`,
    p.contact_unlocks_per_job != null && `${p.contact_unlocks_per_job} candidate unlocks`,
    Number(p.featured_jobs) > 0 && `${p.featured_jobs} Featured Job${Number(p.featured_jobs) === 1 ? '' : 's'}`,
    Number(p.boost_credits) > 0 && `${p.boost_credits} Job Boost / month`,
  ].filter(Boolean);
};

const planCtaLabel = (p) => {
  if (p.cta_label) return p.cta_label;
  if (/enterprise/i.test(p.name || '')) return 'Contact sales';
  const free = Number(p.price_monthly) === 0 || p.billing_type === 'free';
  return free ? 'Post Free Job' : 'Choose plan';
};

const countOrNone = (v) => (v == null || Number(v) === 0 ? 'None' : v);

const LIMIT_ROWS = [
  ['Active jobs', (p) => (p.job_post_limit == null ? 'Unlimited' : p.job_post_limit)],
  ['Job validity', (p) => (p.job_validity_days != null ? `${p.job_validity_days} days` : '—')],
  ['Applications per job', (p) => (p.application_limit == null ? 'Unlimited' : p.application_limit)],
  ['Candidate unlocks / month', (p) => (p.contact_unlocks_per_job == null ? 'Unlimited' : countOrNone(p.contact_unlocks_per_job))],
  ['Featured jobs / month', (p) => countOrNone(p.featured_jobs)],
  ['Job boosts / month', (p) => countOrNone(p.boost_credits)],
  ['Recruiter seats', (p) => p.recruiter_seats ?? 1],
];

const FLAG_ROWS = [
  ['ai_features_enabled', 'AI features'],
  ['candidate_search_enabled', 'Candidate search'],
  ['advanced_filters_enabled', 'Advanced filters'],
  ['ai_matching_enabled', 'AI matching'],
  ['ai_shortlist_enabled', 'AI shortlist'],
  ['interview_tools_enabled', 'Interview tools'],
  ['analytics_enabled', 'Analytics'],
  ['whatsapp_contact_enabled', 'WhatsApp contact'],
  ['bulk_actions_enabled', 'Bulk actions'],
  ['priority_support', 'Priority support'],
];

/* ------------------- guest mock interview (before login) ------------------- */
function GuestMockInterview() {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [stage, setStage] = useState('upload'); // 'upload' | 'interview' | 'locked'
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [limitReached, setLimitReached] = useState(false);
  const [targetRole, setTargetRole] = useState('');
  const [questions, setQuestions] = useState([]);
  const [index, setIndex] = useState(0);
  const [answer, setAnswer] = useState('');
  const [feedback, setFeedback] = useState(null);
  const [difficulty, setDifficulty] = useState('normal');
   const [industry, setIndustry] = useState('');
const [jobType, setJobType] = useState('');   // add this
  // Only for visitors who are not logged in
  const [dragging, setDragging] = useState(false);
  if (localStorage.getItem('token')) return null;

  const handleFileChange = (e) => {
    const f = e.target.files?.[0];
    setError('');
    if (!f) return;
    const ext = f.name.split('.').pop().toLowerCase();
    if (!['pdf', 'docx'].includes(ext)) {
      setFile(null);
      setError('Please upload a PDF or DOCX file.');
      return;
    }
    if (f.size > 5 * 1024 * 1024) {
      setFile(null);
      setError('File is too large. Maximum size is 5 MB.');
      return;
    }
    setFile(f);
  };

  const handleStart = async () => {
    if (!file) return;
    setLoading(true);
    setError('');
    try {
      const form = new FormData();
      form.append('resume', file);
      form.append('difficulty', difficulty);
      const res = await api.post('/guest/mock-interview/start', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setQuestions(res.data.questions || []);
      setTargetRole(res.data.target_role || '');
      setIndex(0);
      setAnswer('');
      setFeedback(null);
      setStage('interview');
    } catch (err) {
      if (err.response?.status === 429) {
        setLimitReached(true);
        setError('You have reached the free limit for now. Register to keep practising.');
      } else {
        setError(
          err.response?.data?.errors?.resume?.[0] ||
            err.response?.data?.message ||
            'Could not start the interview. Please try again.'
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    const current = questions[index];
    if (!current || answer.trim().length < 5) return;
    setLoading(true);
    setError('');
    try {
      const res = await api.post('/guest/mock-interview/feedback', {
        question: current.question,
        category: current.category,
        answer: answer.trim(),
        target_role: targetRole,
      });
      setFeedback(res.data);
    } catch (err) {
      if (err.response?.status === 429) {
        setLimitReached(true);
        setError('You have reached the free limit for now. Register to keep practising.');
      } else {
        setError(err.response?.data?.message || 'Could not evaluate your answer. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleNext = () => {
    if (index + 1 < questions.length) {
      setIndex((i) => i + 1);
      setAnswer('');
      setFeedback(null);
      setError('');
    } else {
      // Free questions are over: ask the visitor to login to continue
      setStage('locked');
    }
  };

  const scoreColor = (s) => (s >= 7 ? 'text-[#10B981]' : s >= 5 ? 'text-[#F59E0B]' : 'text-[#EF4444]');

  return (
      <section id="mock-interview" className="mi-section relative scroll-mt-24 max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
      <span className="mi-blob mi-blob-a" aria-hidden="true" />
      <span className="mi-blob mi-blob-b" aria-hidden="true" />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <Reveal variant="left">
          <p className="inline-flex items-center gap-2 text-xs font-semibold text-[#7C3AED] bg-[#F5F0FA] rounded-full px-3 py-1.5 mb-5">
            <span className="relative flex w-2 h-2">
              <span className="absolute inline-flex w-full h-full rounded-full bg-[#7C3AED] opacity-75 animate-ping motion-reduce:animate-none" />
              <span className="relative inline-flex w-2 h-2 rounded-full bg-[#7C3AED]" />
            </span>
            Free, no login needed
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4">
            Practise a mock interview from your own resume
          </h2>
          <p className="text-gray-500 leading-relaxed mb-6 max-w-md">
            Upload your resume and answer 3 AI-generated questions. You get a score and feedback on every answer.
          </p>

          <ul className="space-y-3 max-w-md">
            {[
              ['target', 'Questions based on your skills and experience'],
              ['bolt', 'Instant score, strengths and improvements'],
              ['shield', 'Your file is not saved'],
            ].map(([icon, t], i) => (
              <li key={t} className="mi-feat" style={{ '--i': i }}>
                <span className="mi-feat-icon"><Icon name={icon} /></span>
                <span className="text-sm font-semibold text-[#1E0F3D]">{t}</span>
              </li>
            ))}
          </ul>

          {/* looping example: question -> typing -> score */}
          <div className="mi-demo" aria-hidden="true">
            <p className="mi-demo-label">Example</p>
            <div className="mi-bubble mi-q">Tell me about a project you are proud of.</div>
            <div className="mi-demo-row">
              <div className="mi-bubble mi-bubble-me mi-typing">
                <span className="typing-dot" /><span className="typing-dot" /><span className="typing-dot" />
              </div>
              <div className="mi-score">Score 8/10 · Clear and specific</div>
            </div>
          </div>
        </Reveal>

        <div key={stage} className="mi-card pop-in assistant-glow relative bg-white rounded-3xl p-6 sm:p-8">
          <span className="mi-float mi-f1" aria-hidden="true">✨ Instant AI feedback</span>
          <span className="mi-float mi-f2" aria-hidden="true">3 free questions</span>
          {stage === 'locked' ? (
            <div className="text-center py-4">
              <div className="w-14 h-14 mx-auto mb-5 rounded-2xl brand-gradient text-white p-3.5 shadow-lg shadow-[#7C3AED]/25">
                <Icon name="shield" />
              </div>
              <h3 className="text-xl font-bold mb-2">You have completed your 3 free questions</h3>
              <p className="text-sm text-gray-500 leading-relaxed mb-6 max-w-sm mx-auto">
                Please login to continue this mock interview with more questions and feedback.
              </p>
              <button
                type="button"
                onClick={() => navigate('/login')}
                className="shine-btn brand-gradient text-white w-full px-8 py-3.5 rounded-xl font-semibold text-sm shadow-[0_10px_30px_-8px_rgba(124,58,237,0.6)]"
              >
                Login to continue
              </button>
              <p className="text-xs text-gray-500 mt-4">
                New to PlanB?{' '}
                <Link to="/register" className="font-semibold text-[#7C3AED] hover:underline">
                  Register free
                </Link>
              </p>
            </div>
          ) : stage === 'upload' ? (
            <>
              <p className="font-semibold text-sm mb-1">Upload your resume</p>
              <p className="text-xs text-gray-500 mb-4">PDF or DOCX, up to 5 MB. Text-based files work best.</p>

              <input
                ref={fileInputRef}
                type="file"
                accept=".pdf,.docx"
                onChange={handleFileChange}
                className="hidden"
              />
                            <button
                type="button"
                onClick={() => fileInputRef.current?.click()}
                onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
                onDragLeave={() => setDragging(false)}
                onDrop={(e) => {
                  e.preventDefault();
                  setDragging(false);
                  handleFileChange({ target: { files: e.dataTransfer.files } });
                }}
                className={`mi-drop w-full rounded-2xl p-6 text-center focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7C3AED]/50 ${dragging ? 'mi-drop-on' : ''} ${file ? 'mi-drop-done' : ''}`}
              >
                <span className="mi-drop-icon bob block w-12 h-12 mx-auto mb-3 rounded-2xl brand-gradient text-white p-3">
                  <Icon name={file ? 'check' : 'doc'} />
                </span>
                <span className="block text-sm font-semibold text-[#1E0F3D] break-all">
                  {file ? file.name : 'Click to choose or drop your resume'}
                </span>
                <span className="block text-xs text-gray-500 mt-1">
                  {file ? 'Ready. Click to change the file.' : 'PDF or DOCX'}
                </span>
              </button>

              <div className="mt-4">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Difficulty</p>
                <div className="inline-flex bg-[#F5F0FA] rounded-full p-1">
                  {[
                    { key: 'easy', label: 'Easy' },
                    { key: 'normal', label: 'Normal' },
                    { key: 'hard', label: 'Hard' },
                  ].map((d) => (
                    <button
                      key={d.key}
                      type="button"
                      onClick={() => setDifficulty(d.key)}
                      disabled={loading}
                      className={`px-5 py-1.5 rounded-full text-sm font-semibold transition disabled:opacity-60 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7C3AED]/50 ${
                        difficulty === d.key
                          ? 'brand-gradient text-white shadow-md shadow-[#7C3AED]/25'
                          : 'text-gray-600 hover:text-[#7C3AED]'
                      }`}
                    >
                      {d.label}
                    </button>
                  ))}
                </div>
              </div>

              {error && <p className="mt-3 text-sm text-red-500">{error}</p>}

              {limitReached ? (
                <Link
                  to="/register"
                  className="shine-btn brand-gradient text-white mt-5 inline-block w-full text-center px-8 py-3.5 rounded-xl font-semibold text-sm"
                >
                  Register to continue
                </Link>
              ) : (
                <button
                  type="button"
                  onClick={handleStart}
                  disabled={!file || loading}
className={`shine-btn brand-gradient text-white mt-5 w-full px-8 py-3.5 rounded-xl font-semibold text-sm shadow-[0_10px_30px_-8px_rgba(124,58,237,0.6)] disabled:opacity-50 ${file && !loading ? 'cta-glow' : ''}`}
                >
                  {loading ? 'Reading your resume...' : 'Start free mock interview'}
                </button>
              )}
            </>
          ) : (
            <>
              {/* progress */}
              <div className="flex items-center justify-between mb-4">
                <p className="text-xs font-semibold text-gray-500">
                  Question {index + 1} of {questions.length}
                  <span className="text-gray-300"> · </span>
                  {questions[index]?.category}
                </p>
                <div className="flex gap-1.5">
                  {questions.map((_, i) => (
                    <span
                      key={i}
                      className={`w-6 h-1.5 rounded-full ${i <= index ? 'brand-gradient' : 'bg-purple-100'}`}
                    />
                  ))}
                </div>
              </div>

              <p className="font-bold text-lg mb-4">{questions[index]?.question}</p>

              <textarea
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
                rows={5}
                disabled={!!feedback || loading}
                placeholder="Type your answer as if you are in a real interview..."
                className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#7C3AED]/40 disabled:bg-gray-50"
              />

              {error && <p className="mt-3 text-sm text-red-500">{error}</p>}

              {!feedback ? (
                limitReached ? (
                  <Link
                    to="/register"
                    className="shine-btn brand-gradient text-white mt-4 inline-block w-full text-center px-8 py-3.5 rounded-xl font-semibold text-sm"
                  >
                    Register to continue
                  </Link>
                ) : (
                  <button
                    type="button"
                    onClick={handleSubmit}
                    disabled={loading || answer.trim().length < 5}
                    className="shine-btn brand-gradient text-white mt-4 w-full px-8 py-3.5 rounded-xl font-semibold text-sm disabled:opacity-50"
                  >
                    {loading ? 'Evaluating...' : 'Submit answer'}
                  </button>
                )
              ) : (
                <div className="mt-5 pt-5 border-t border-purple-100">
                  <div className="flex items-center gap-3 mb-4">
                    <span className={`text-3xl font-extrabold tabular-nums ${scoreColor(feedback.score)}`}>
                      {feedback.score}/10
                    </span>
                    <span className="text-xs text-gray-500">Your score for this answer</span>
                  </div>

                  {feedback.strengths?.length > 0 && (
                    <div className="mb-3">
                      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">What went well</p>
                      <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
                        {feedback.strengths.map((s, i) => <li key={i}>{s}</li>)}
                      </ul>
                    </div>
                  )}

                  {feedback.improvements?.length > 0 && (
                    <div className="mb-3">
                      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">How to improve</p>
                      <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
                        {feedback.improvements.map((s, i) => <li key={i}>{s}</li>)}
                      </ul>
                    </div>
                  )}

                  {feedback.sample_answer && (
                    <div className="bg-[#FBF5FF] border border-purple-100 rounded-xl p-3 mb-4">
                      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Sample better answer</p>
                      <p className="text-sm text-gray-700">{feedback.sample_answer}</p>
                    </div>
                  )}

                  <button
                    type="button"
                    onClick={handleNext}
                    className="shine-btn brand-gradient text-white w-full px-8 py-3.5 rounded-xl font-semibold text-sm shadow-[0_10px_30px_-8px_rgba(124,58,237,0.6)]"
                  >
                    Next question
                  </button>
                  {index + 1 >= questions.length && (
                    <p className="text-xs text-gray-500 text-center mt-3">
                      That was your 3rd free question. Login to continue this mock interview.
                    </p>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
}

/* ------------------ "What are you looking for?" assistant ------------------ */
function PathAssistant({ isLoggedIn }) {
  const [picked, setPicked] = useState(null);
  const [showReply, setShowReply] = useState(false);
  const [registerPreset, setRegisterPreset] = useState(null);
  const timerRef = useRef(null);
  const [greeted, setGreeted] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setGreeted(true), 1000);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const experienced = { role: 'job_seeker', experienceLevel: 'experienced' };

  const options = [
    { key: 'better', label: 'A better job', reply: 'Looking for your next move? Tell us about your skills and experience and discover opportunities that match.', cta: 'Explore Jobs', to: '/jobs', preset: experienced },
    { key: 'higher', label: 'A higher-paying job', reply: 'Your skills have value. Explore opportunities based on your experience, skills and career goals.', cta: 'Find Better Opportunities', to: '/jobs', preset: experienced },
    { key: 'change', label: "I'm changing careers", reply: 'Planning a career change? Discover roles where your existing skills and experience can open new opportunities.', cta: 'Explore Career Options', to: '/jobs', preset: experienced },
    { key: 'near', label: 'A job near me', reply: 'Looking for opportunities close to you? Search jobs by location and find openings in your preferred area.', cta: 'Search Jobs', to: '/#jobs' },
    { key: 'open', label: "I'm open to opportunities", reply: 'Not actively searching but open to the right opportunity? Create your profile and let employers discover you.', cta: 'Create My Profile', to: isLoggedIn ? '/dashboard' : '/register', preset: { role: 'job_seeker' }, registerOnly: true },
  ];

  const choose = (opt) => {
    clearTimeout(timerRef.current);
    setPicked(opt);
    setShowReply(false);
    timerRef.current = setTimeout(() => setShowReply(true), 900);
  };

  const glow = <div className="absolute -inset-6 rounded-[2.5rem] bg-gradient-to-br from-[#7C3AED]/25 to-[#DB2777]/20 blur-3xl" aria-hidden="true" />;

  // Registration mode: the card becomes the registration chat
  if (registerPreset) {
    return (
      <div className="relative">
        {glow}
        <div className="relative">
          <RegisterChat embedded preset={registerPreset} onClose={() => setRegisterPreset(null)} />
        </div>
      </div>
    );
  }

  const canRegister = !!picked?.preset && !isLoggedIn;

  return (
    <div className="relative">
      {glow}
      <div className="relative bg-white rounded-3xl border border-purple-100 shadow-[0_40px_80px_-30px_rgba(124,58,237,0.45)] overflow-hidden flex flex-col h-[520px] assistant-glow" aria-live="polite">
        <div className="animated-gradient text-white px-5 py-4 flex items-center gap-3">
          <span className="w-9 h-9 rounded-full bg-white text-[#E11D2E] flex items-center justify-center font-extrabold shrink-0 pulse-ring">B</span>
          <div>
            <p className="font-bold text-sm leading-tight flex items-center gap-2">
              PlanB Assistant
              <span className="relative flex w-2 h-2">
                <span className="absolute inline-flex w-full h-full rounded-full bg-[#4ADE80] opacity-75 animate-ping motion-reduce:animate-none" />
                <span className="relative inline-flex w-2 h-2 rounded-full bg-[#4ADE80]" />
              </span>
            </p>
            <p className="text-xs text-white/80">Tell us what you need. We'll help you find the right opportunities.</p>
          </div>
        </div>

        <div className="p-5 flex-1 overflow-y-auto flex flex-col gap-2.5">
          {!greeted && (
            <div className="swap w-fit bg-[#F5F0FA] px-4 py-3 rounded-2xl rounded-bl-sm flex gap-1.5" aria-hidden="true">
              <span className="typing-dot" /><span className="typing-dot" /><span className="typing-dot" />
            </div>
          )}
          <div className={`swap max-w-[88%] bg-[#F5F0FA] text-sm font-semibold px-4 py-2.5 rounded-2xl rounded-bl-sm ${greeted ? '' : 'hidden'}`}>
            What are you looking for right now?
          </div>
          {picked && (
            <div key={`me-${picked.key}`} className="swap max-w-[88%] self-end brand-gradient text-white text-sm px-4 py-2.5 rounded-2xl rounded-br-sm">
              {picked.label}
            </div>
          )}
          {picked && !showReply && (
            <div key={`typing-${picked.key}`} className="swap w-fit bg-[#F5F0FA] px-4 py-3 rounded-2xl rounded-bl-sm flex gap-1.5" aria-hidden="true">
              <span className="typing-dot" /><span className="typing-dot" /><span className="typing-dot" />
            </div>
          )}
          {picked && showReply && (
            <div key={`bot-${picked.key}`} className="swap max-w-[92%] bg-[#F5F0FA] text-sm px-4 py-2.5 rounded-2xl rounded-bl-sm">
              <p>{picked.reply}</p>
              <div className="flex flex-wrap items-center gap-2 mt-2.5">
                {picked.registerOnly && canRegister ? (
                  <button
                    type="button"
                    onClick={() => setRegisterPreset(picked.preset)}
                    className="inline-flex items-center gap-1.5 brand-gradient text-white text-xs font-bold px-3.5 py-2 rounded-lg hover:opacity-90 transition"
                  >
                    {picked.cta} <span className="w-3.5 h-3.5"><Icon name="arrow" /></span>
                  </button>
                ) : (
                  <>
                    <Link
                      to={picked.to}
                      className="inline-flex items-center gap-1.5 bg-[#DB2777] text-white text-xs font-bold px-3.5 py-2 rounded-lg hover:opacity-90 transition"
                    >
                      {picked.cta} <span className="w-3.5 h-3.5"><Icon name="arrow" /></span>
                    </Link>
                    {canRegister && (
                      <button
                        type="button"
                        onClick={() => setRegisterPreset(picked.preset)}
                        className="inline-flex items-center gap-1.5 bg-white text-[#7C3AED] border border-purple-100 text-xs font-semibold px-3.5 py-2 rounded-lg hover:bg-[#FBF5FF] transition"
                      >
                        Create my free profile
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          )}
        </div>

        {!picked && greeted && (
          <p className="swap px-5 pb-2 text-xs font-semibold text-[#DB2777] flex items-center gap-1.5">
            Tap an option to get started <span className="inline-block animate-bounce motion-reduce:animate-none">👇</span>
          </p>
        )}
        <div className="px-5 pb-5 flex flex-wrap gap-2">
          {options.map((o, idx) => (
            <button
              key={o.key} type="button" onClick={() => choose(o)} aria-pressed={picked?.key === o.key} style={{ animationDelay: `${idx * 110 + 1100}ms` }}
              className={`chip-in hover:-translate-y-0.5 hover:shadow-md px-3.5 py-2 rounded-full text-xs font-semibold border transition focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7C3AED]/50 ${picked?.key === o.key ? 'brand-gradient text-white border-transparent shadow-md shadow-[#7C3AED]/30' : 'bg-white text-[#7C3AED] border-[#7C3AED]/40 hover:bg-[#F5F0FA]'}`}
            >
              {o.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ------------------------------- FAQ ------------------------------- */
function FaqSection() {
  const [open, setOpen] = useState(0); // first question open by default

  return (
    <section id="faq" className="scroll-mt-24 bg-gradient-to-br from-[#FBF5FF] to-[#FDF0F6] py-20 lg:py-24">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-[1fr_1.7fr] gap-10 lg:gap-16 items-start">

        {/* Left: heading + help card */}
        <Reveal variant="left" className="lg:sticky lg:top-28">
          <p className="inline-block text-xs font-semibold text-[#7C3AED] bg-white border border-purple-100 rounded-full px-3 py-1.5 mb-5 shadow-sm">
            FAQ
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-3">Things people ask us.</h2>
          <p className="text-gray-500 leading-relaxed mb-8 max-w-sm">
            Short, honest answers to the questions we hear most.
          </p>

          <div className="bg-white border border-purple-100 rounded-2xl p-5 shadow-sm max-w-sm">
            <div className="w-10 h-10 rounded-xl brand-gradient text-white p-2.5 mb-3">
              <Icon name="chat" />
            </div>
            <p className="font-bold text-[#1E0F3D] mb-1">Still have questions?</p>
            <p className="text-sm text-gray-500 mb-4">Our team is happy to help you out.</p>
            <Link to="/contact-us" className="inline-flex items-center gap-2 text-sm font-bold text-[#DB2777] hover:underline">
              Contact us <span className="w-4 h-4"><Icon name="arrow" /></span>
            </Link>
          </div>
        </Reveal>

        {/* Right: accordion */}
        <div className="space-y-4">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={f.q} delay={i * 70}>
                <div
                  className={`rounded-2xl border bg-white transition-all duration-300 ${
                    isOpen
                      ? 'border-[#DB2777]/40 shadow-[0_20px_40px_-20px_rgba(124,58,237,0.45)]'
                      : 'border-purple-100 hover:border-[#7C3AED]/40 hover:shadow-md'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-panel-${i}`}
                    className="w-full flex items-center gap-4 text-left px-5 py-5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7C3AED]/50 rounded-2xl"
                  >
                    <span className={`w-9 h-9 rounded-xl flex items-center justify-center text-sm font-extrabold shrink-0 transition-colors duration-300 ${isOpen ? 'brand-gradient text-white' : 'bg-[#F5F0FA] text-[#7C3AED]'}`}>
                      {String(i + 1).padStart(2, '0')}
                    </span>
                    <span className="flex-1 font-semibold text-[#1E0F3D]">{f.q}</span>
                    <span className={`w-8 h-8 rounded-full flex items-center justify-center text-xl leading-none shrink-0 transition-all duration-300 ${isOpen ? 'rotate-45 brand-gradient text-white' : 'bg-[#F5F0FA] text-[#DB2777]'}`} aria-hidden="true">
                      +
                    </span>
                  </button>

                  <div className={`grid transition-all duration-300 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                    <div className="overflow-hidden">
                      <p id={`faq-panel-${i}`} className="pl-[4.25rem] pr-6 pb-5 text-sm text-gray-500 leading-relaxed">
                        {f.a}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}

/* ------------------------- NEW SECTION COMPONENTS ------------------------- */
function WhyPlanBSection() {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  const [applied, setApplied] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (!('IntersectionObserver' in window)) { setInView(true); return; }
    const io = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setInView(true); io.disconnect(); } },
      { threshold: 0.2 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const matches = [
    { role: 'Frontend Developer', meta: 'Bengaluru · Full-time', pct: 94 },
    { role: 'Business Analyst', meta: 'Remote · Full-time', pct: 88 },
    { role: 'Customer Success Executive', meta: 'Pune · Hybrid', pct: 81 },
  ];
  const chips = [
    ['IT', '/jobs/it'], ['Healthcare', '/jobs/healthcare'], ['Finance', '/jobs/banking-finance'],
    ['Sales', '/jobs/sales'], ['Marketing', '/jobs/digital-marketing'], ['Manufacturing', '/jobs/manufacturing'],
    ['Logistics', '/jobs/logistics'], ['Hospitality', '/jobs/hospitality'], ['BPO', '/jobs/bpo'], ['Education', '/jobs/education'],
  ];
  const stages = [
    ['Freshers', 'Start your career', '/jobs?experience=fresher'],
    ['Experienced', 'Make your next move', '/jobs'],
    ['Remote', 'Work from anywhere', '/jobs?work_mode=work_from_home'],
  ];

  return (
    <section id="why-planb" ref={ref} className={`wp-section scroll-mt-24 ${inView ? 'wp-in' : ''}`}>
      <div className="wp-wrap">
        <div className="wp-head">
          <h2>Job hunting shouldn’t feel like a full-time job.</h2>
          <div>
            <p className="wp-sub">
              PlanB Jobs brings job discovery, employer connections and recruitment tools together in one place, so you spend less time searching.
            </p>
            <Link to="/jobs" className="wp-cta">
              Browse jobs <span style={{ width: 16, height: 16 }}><Icon name="arrow" /></span>
            </Link>
          </div>
        </div>

        <div className="wp-grid">
          <article className="wp-card wp-a">
            <div className="wp-top">
              <div className="wp-icon"><Icon name="target" /></div>
              <div>
                <h3 className="wp-title">AI-powered job discovery</h3>
                <p className="wp-body">Explore relevant opportunities based on your skills, experience and preferences.</p>
              </div>
            </div>
            <div className="wp-mock">
              <p className="wp-mock-label">Your skills</p>
              <div className="wp-chips" style={{ marginBottom: 14 }}>
                {['React', 'Excel', 'Communication', 'SQL'].map((s) => <span key={s} className="wp-chip">{s}</span>)}
              </div>
              <p className="wp-mock-label">Example matches</p>
              {matches.map((m, i) => (
                <div className="wp-job" key={m.role}>
                  <div><b>{m.role}</b><small>{m.meta}</small></div>
                  <span className="wp-pct">{m.pct}%</span>
                  <div className="wp-bar"><i style={{ '--w': `${m.pct}%`, '--d': `${0.3 + i * 0.2}s` }} /></div>
                </div>
              ))}
            </div>
          </article>

          <article className="wp-card wp-b">
            <div className="wp-top">
              <div className="wp-icon"><Icon name="shield" /></div>
              <div>
                <h3 className="wp-title">Verified employers</h3>
                <p className="wp-body">Discover employers who have completed the platform’s verification process.</p>
              </div>
            </div>
            <div className="wp-mock">
              <div className="wp-co">
                <span className="wp-logo">A</span>
                <div><b>Acme Technologies</b><small>Example employer · Bengaluru</small></div>
                <span className="wp-verified"><span style={{ width: 14, height: 14 }}><Icon name="check" /></span>Verified</span>
              </div>
            </div>
          </article>

          <article className="wp-card wp-c">
            <div className="wp-top">
              <div className="wp-icon"><Icon name="briefcase" /></div>
              <div>
                <h3 className="wp-title">Opportunities across industries</h3>
                <p className="wp-body">From IT and healthcare to logistics and hospitality. Tap one to see jobs.</p>
              </div>
            </div>
            <div className="wp-chips">
              {chips.map(([label, to]) => <Link key={label} to={to} className="wp-chip">{label}</Link>)}
            </div>
          </article>

          <article className="wp-card wp-d">
            <div className="wp-top">
              <div className="wp-icon"><Icon name="cursor" /></div>
              <div>
                <h3 className="wp-title">Simple applications</h3>
                <p className="wp-body">Create your profile once and apply to relevant jobs without extra forms.</p>
              </div>
            </div>
            <div className="wp-mock wp-apply">
              <button type="button" className={`wp-apply-btn ${applied ? 'done' : ''}`} onClick={() => setApplied((v) => !v)}>
                {applied ? 'Applied ✓' : 'Apply with profile'}
              </button>
              <small>{applied ? 'Done. That’s all it takes.' : 'Try it: one tap.'}</small>
            </div>
          </article>

          <article className="wp-card wp-e">
            <div className="wp-top">
              <div className="wp-icon"><Icon name="cap" /></div>
              <div>
                <h3 className="wp-title">Opportunities for everyone</h3>
                <p className="wp-body">Whether you’re a fresher or an experienced professional, your next opportunity starts here.</p>
              </div>
            </div>
            <div className="wp-stages">
              {stages.map(([name, sub, to]) => (
                <Link key={name} to={to} className="wp-stage">{name}<small>{sub}</small></Link>
              ))}
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}

function IndustrySection() {
  return (
    <section id="industries" className="scroll-mt-24 bg-gradient-to-br from-[#FBF5FF] to-[#FDF0F6] py-12 lg:py-14">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <div className="max-w-2xl mb-4 mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-3">Find Your Space. Find Your Industry.</h2>
            <p className="text-gray-500">Explore jobs by industry and discover where your skills fit best.</p>
          </div>
        </Reveal>

        <div className="marquee-mask overflow-hidden py-4">
          <div className="marquee-ltr flex w-max hover:[animation-play-state:paused]" style={{ animationDuration: '70s' }}>
            {[...INDUSTRIES, ...INDUSTRIES].map((ind, i) => (
              <div key={`${ind.name}-${i}`} className="shrink-0 w-[230px] mr-4">
                <Link to={ind.to} className="ind-card">
                  <img
                    src={ind.image}
                    alt={ind.name}
                    loading="lazy"
                    onError={(e) => { e.currentTarget.style.display = 'none'; }}
                  />
                  <span className="ind-shade" aria-hidden="true" />
                  <span className="ind-sheen" aria-hidden="true" />
                  <span className="ind-num">{String((i % INDUSTRIES.length) + 1).padStart(2, '0')}</span>
                  <span className="ind-arrow" aria-hidden="true"><Icon name="arrow" /></span>
                  <div className="ind-body">
                    <p className="ind-title">{ind.name}</p>
                    <div className="ind-bar" />
                    <span className="ind-cta">View jobs <span className="w-3.5 h-3.5"><Icon name="arrow" /></span></span>
                  </div>
                </Link>
              </div>
            ))}
                    </div>
        </div>

        <div className="text-center mt-6">
          <Link
            to="/jobs-by-industry"
            className="shine-btn brand-gradient text-white inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold text-sm shadow-[0_10px_30px_-8px_rgba(124,58,237,0.6)]"
          >
            View all industries <span className="w-4 h-4"><Icon name="arrow" /></span>
          </Link>
        </div>
      </div>
    </section>
  );
}

const CITIES = [
  { name: 'Mumbai', state: 'Maharashtra', image: imgMumbai },
  { name: 'Delhi', state: 'Delhi NCR', image: imgDelhi },
  { name: 'Bengaluru', state: 'Karnataka', image: imgBengaluru },
  { name: 'Hyderabad', state: 'Telangana', image: imgHyderabad },
  { name: 'Kolkata', state: 'West Bengal', image: imgKolkata },
];


const SEO_CITIES = landingData.CITIES || [];

const cityPath = (name) => {
  const n = name.toLowerCase();
  const match = SEO_CITIES.find(
    (c) =>
      c.slug === n ||
      c.name.toLowerCase() === n ||
      (c.listing?.locations || []).some((l) => l.toLowerCase() === n)
  );
  return match ? match.path : `/jobs?location=${encodeURIComponent(name)}`;
};


function CitySection() {
  return (
    <section id="cities" className="scroll-mt-24 bg-white py-12 lg:py-14">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <div className="max-w-2xl mb-4 mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-3">Find Jobs in Your City.</h2>
            <p className="text-gray-500">Pick a city and see the openings near you.</p>
          </div>
        </Reveal>

        <div className="marquee-mask overflow-hidden py-4">
          <div className="marquee-rtl flex w-max hover:[animation-play-state:paused]" style={{ animationDuration: '60s' }}>
            {[...CITIES, ...CITIES, ...CITIES, ...CITIES].map((c, i) => (
              <div key={`${c.name}-${i}`} className="shrink-0 w-[230px] mr-4">
                <Link to={cityPath(c.name)} className="ind-card">
                  <img
                    src={c.image}
                    alt={`Jobs in ${c.name}`}
                    loading="lazy"
                    onError={(e) => { e.currentTarget.style.display = 'none'; }}
                  />
                  <span className="ind-shade" aria-hidden="true" />
                  <span className="ind-sheen" aria-hidden="true" />
                  <span className="ind-num" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                    <span className="w-3 h-3"><Icon name="pin" /></span>{c.state}
                  </span>
                  <span className="ind-arrow" aria-hidden="true"><Icon name="arrow" /></span>
                  <div className="ind-body">
                    <p className="ind-title">{c.name}</p>
                    <div className="ind-bar" />
                    <span className="ind-cta">Jobs in {c.name} <span className="w-3.5 h-3.5"><Icon name="arrow" /></span></span>
                  </div>
                </Link>
              </div>
            ))}
                          </div>
        </div>

        <div className="text-center mt-6">
          <Link
            to="/jobs-by-location"
            className="shine-btn brand-gradient text-white inline-flex items-center gap-2 px-8 py-3 rounded-xl font-semibold text-sm shadow-[0_10px_30px_-8px_rgba(124,58,237,0.6)]"
          >
            View all cities <span className="w-4 h-4"><Icon name="arrow" /></span>
          </Link>
        </div>
      </div>
    </section>
  );
}


function CareerStageSection() {
  return (
    <section id="career-stage" className="scroll-mt-24 max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24">
      <Reveal className="text-center">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-3">Jobs for every career stage.</h2>
        <p className="text-gray-500 max-w-xl mx-auto mb-10">Everyone starts in a different place. Here is where to begin.</p>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {CAREER_STAGES.map((t, i) => (
          <Reveal key={t.who} delay={i * 120} className="h-full">
            <TiltCard className="h-full">
              <div className={`group card-shine relative overflow-hidden h-full flex flex-col rounded-3xl p-7 border border-purple-100 transition-all duration-300 hover:shadow-[0_30px_60px_-25px_rgba(124,58,237,0.5)] ${i % 2 === 0 ? 'bg-gradient-to-br from-[#FBF5FF] to-white' : 'bg-gradient-to-br from-[#FDF0F6] to-white'}`}>
                <span className="bob icon-hover w-12 h-12 rounded-2xl bg-white border border-purple-100 shadow-sm flex items-center justify-center text-2xl mb-6" aria-hidden="true">{t.emoji}</span>
                <h3 className="text-xl font-bold mb-2">{t.who}</h3>
                <p className="text-sm text-gray-500 leading-relaxed mb-6 flex-1">{t.body}</p>
                <Link to={t.to} className="inline-flex items-center gap-2 font-bold text-sm text-[#DB2777] hover:underline w-fit">
                  {t.cta} <span className="w-4 h-4 transition-transform group-hover:translate-x-1"><Icon name="arrow" /></span>
                </Link>
              </div>
            </TiltCard>
          </Reveal>
        ))}
      </div>
    </section>
  );
}

function AiRecruitmentSection() {
  // NOTE: only keep claims here that are implemented and tested.
  return (
    <section id="ai-recruitment" className="px-6 lg:px-8 py-10">
      <div className="max-w-7xl mx-auto relative overflow-hidden rounded-[2rem] brand-gradient px-8 lg:px-16 py-14 lg:py-20 text-white shadow-[0_40px_80px_-30px_rgba(124,58,237,0.6)]">
        <div className="absolute inset-0 opacity-15 pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '22px 22px' }} aria-hidden="true" />
        <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-white/20 blur-3xl float-slower pointer-events-none" aria-hidden="true" />
<div className="absolute -bottom-24 -left-16 w-72 h-72 rounded-full bg-[#DB2777]/40 blur-3xl float-slow pointer-events-none" aria-hidden="true" />
        <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="text-4xl sm:text-5xl font-extrabold tracking-tight leading-[1.05] mb-5">Less Searching. More Matching.</h2>
            <p className="text-white/85 text-base lg:text-lg leading-relaxed max-w-xl mb-8">
              Finding a job should be about finding the right fit, not sending hundreds of applications. PlanB Jobs is designed to make job discovery smarter through AI-powered recruitment capabilities.
            </p>
            <Link to="/jobs" className="inline-block bg-white text-[#7C3AED] px-8 py-3.5 rounded-xl font-bold text-sm hover:opacity-90 transition">
              Discover AI Job Matching
            </Link>
          </div>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
           {AI_HIGHLIGHTS.map((h, i) => (
  <li key={h} className="list-none">
    <Reveal delay={i * 80} className="h-full">
      <div className="flex items-center gap-3 bg-white/15 border border-white/20 rounded-2xl px-5 py-4 text-sm font-semibold transition duration-300 hover:bg-white/25 hover:-translate-y-1 hover:scale-[1.02]">
        <span className="w-5 h-5 rounded-full bg-white/25 p-1 shrink-0"><Icon name="check" /></span>{h}
      </div>
    </Reveal>
  </li>
))}
          </ul>
        </div>
      </div>
    </section>
  );
}

function EmployerSection({ employerLink }) {
  return (
    <section id="employers" className="scroll-mt-24 px-6 lg:px-8 py-20 lg:py-24">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <Reveal variant="left">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4">Great Teams Start With Great Hiring.</h2>
          <p className="text-gray-500 leading-relaxed mb-8 max-w-md">
            Looking for your next employee? Post vacancies, connect with potential candidates and manage your recruitment journey through PlanB Jobs.
          </p>
          <Link to={employerLink} className="shine-btn brand-gradient text-white inline-block px-8 py-3.5 rounded-xl font-semibold text-sm shadow-[0_10px_30px_-8px_rgba(124,58,237,0.6)]">
            Start Hiring
          </Link>
        </Reveal>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {EMPLOYER_FEATURES.map((f, i) => (
            <li key={f} className="list-none">
              <Reveal delay={i * 80} className="h-full">
                <div className="flex items-center gap-3 bg-white border border-purple-100 rounded-2xl px-5 py-4 text-sm font-semibold text-[#1E0F3D] shadow-sm transition duration-300 hover:-translate-y-1 hover:border-[#DB2777]/40 hover:shadow-lg">
                  <span className="w-6 h-6 rounded-full brand-gradient text-white p-1.5 shrink-0"><Icon name="check" /></span>{f}
                </div>
              </Reveal>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

function FinalCta({ employerLink }) {
  return (
    <section className="px-6 lg:px-8 pb-20 lg:pb-24">
      <Reveal variant="zoom">
        <div className="max-w-7xl mx-auto animated-gradient rounded-[2rem] relative overflow-hidden px-8 lg:px-16 py-14 lg:py-16 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center shadow-[0_40px_80px_-30px_rgba(124,58,237,0.6)]">
          <div className="absolute inset-0 opacity-15 pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '22px 22px' }} aria-hidden="true" />
          <div className="relative">
            <h2 className="text-3xl sm:text-4xl font-bold text-white tracking-tight mb-3">Your Next Opportunity Is Waiting.</h2>
            <p className="text-white/80 max-w-md">Take the next step in your career or find the right people for your business.</p>
          </div>
          <div className="relative flex flex-wrap gap-3 lg:justify-self-end">
            <Link to="/jobs" className="bg-white text-[#7C3AED] px-8 py-3.5 rounded-xl font-bold text-sm hover:opacity-90 transition">Find Jobs</Link>
            <Link to={employerLink} className="border border-white/50 text-white px-8 py-3.5 rounded-xl font-semibold text-sm hover:bg-white/10 transition">Post a Job</Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
  
}


function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <button
      type="button"
      aria-label="Back to top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={`fixed bottom-6 right-6 z-[90] w-12 h-12 rounded-full brand-gradient text-white p-3.5 shadow-lg shadow-[#7C3AED]/40 transition-all duration-300 hover:-translate-y-1 ${show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}
    >
      <span className="block w-full h-full -rotate-90"><Icon name="arrow" /></span>
    </button>
  );
}


/* ------------------------------- page ------------------------------- */
function Home() {
  const [keyword, setKeyword] = useState('');
  const [location, setLocation] = useState('');
  const [skills, setSkills] = useState('');
 const [industry, setIndustry] = useState('');
const [jobType, setJobType] = useState('');   // add this
  const [departments, setDepartments] = useState([]);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
  const [searchOpen, setSearchOpen] = useState(false);
  const [keywordSuggestions, setKeywordSuggestions] = useState([]);
  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [showKeywordSuggestions, setShowKeywordSuggestions] = useState(false);
  const [showLocationSuggestions, setShowLocationSuggestions] = useState(false);
  const [plans, setPlans] = useState([]);
  const [creditPacks, setCreditPacks] = useState([]);
  const [jobBoosts, setJobBoosts] = useState([]);
  const [planTab, setPlanTab] = useState('plans'); // 'plans' | 'credits' | 'boost'
  const [selectedPlanKey, setSelectedPlanKey] = useState(null);
  const selectedPlan = plans.find((p) => (p.id || p.name) === selectedPlanKey) || null;

  const keywordDebounceRef = useRef(null);
  const locationDebounceRef = useRef(null);
  const searchFormRef = useRef(null);
  const navigate = useNavigate();
  const routerLocation = useLocation();
  const isLoggedIn = !!localStorage.getItem('token');
  const [user] = useState(() => {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  });

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if (!selectedPlan) return;
    const onKey = (e) => e.key === 'Escape' && setSelectedPlanKey(null);
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [selectedPlan]);

  useEffect(() => {
    const toList = (res) => (Array.isArray(res.data) ? res.data : (res.data?.data ?? []));
    Promise.allSettled([
      api.get('/plans', { params: { type: 'subscription' } }),
      api.get('/candidate-credit-packs'),
      api.get('/job-boosts'),
    ]).then(([p, c, b]) => {
      setPlans(p.status === 'fulfilled' ? toList(p.value) : []);
      setCreditPacks(c.status === 'fulfilled' ? toList(c.value) : []);
      setJobBoosts(b.status === 'fulfilled' ? toList(b.value) : []);
    });
  }, []);

  useEffect(() => {
    api.get('/job-categories')
      .then((res) => setDepartments(Array.isArray(res.data) ? res.data : (res.data?.data ?? [])))
      .catch(() => setDepartments([]));
  }, []);

  useEffect(() => {
    const id = routerLocation.hash.replace('#', '');
    if (!id) return;
    const t = setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 100);
    return () => clearTimeout(t);
  }, [routerLocation.hash, plans.length, creditPacks.length, jobBoosts.length]);

  useEffect(() => {
    if (user?.role === 'agent') navigate('/agent/dashboard', { replace: true });
  }, [user, navigate]);

  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'PlanB Jobs – Find Jobs in India | AI-Powered Job Portal';

    let meta = document.querySelector('meta[name="description"]');
    const created = !meta;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    const prevDesc = meta.getAttribute('content');
    meta.setAttribute(
      'content',
      'Find jobs in India with PlanB Jobs. Discover fresher and experienced job opportunities across industries, connect with employers and explore AI-powered job matching.'
    );

    return () => {
      document.title = prevTitle;
      if (created) meta.remove();
      else if (prevDesc !== null) meta.setAttribute('content', prevDesc);
    };
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (searchFormRef.current && !searchFormRef.current.contains(e.target)) {
        setShowKeywordSuggestions(false);
        setShowLocationSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const fetchSuggestions = async (endpoint, query) => {
    try {
      const res = await api.post(endpoint, { query });
      return res.data.suggestions || [];
    } catch {
      return [];
    }
  };

  const handleKeywordChange = (e) => {
    const value = e.target.value;
    setKeyword(value);
    clearTimeout(keywordDebounceRef.current);
    if (value.trim().length < 2) { setKeywordSuggestions([]); setShowKeywordSuggestions(false); return; }
    keywordDebounceRef.current = setTimeout(async () => {
      const s = await fetchSuggestions('/ai/suggest-keywords', value.trim());
      setKeywordSuggestions(s);
      setShowKeywordSuggestions(s.length > 0);
    }, 300);
  };

  const handleLocationChange = (e) => {
    const value = e.target.value;
    setLocation(value);
    clearTimeout(locationDebounceRef.current);
    if (value.trim().length < 2) { setLocationSuggestions([]); setShowLocationSuggestions(false); return; }
    locationDebounceRef.current = setTimeout(async () => {
      const s = await fetchSuggestions('/ai/suggest-cities', value.trim());
      setLocationSuggestions(s);
      setShowLocationSuggestions(s.length > 0);
    }, 300);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setShowKeywordSuggestions(false);
    setShowLocationSuggestions(false);
    setSearchOpen(false);
    const params = new URLSearchParams();
    const combinedKeyword = [keyword.trim(), skills.trim()].filter(Boolean).join(' ');
    if (combinedKeyword) params.set('keyword', combinedKeyword);
    if (location) params.set('location', location);
    if (industry) params.set('department', industry);
if (jobType) params.set('job_type', jobType);   // add this
    navigate(`/jobs?${params.toString()}`);
  };

  const employerLink = isLoggedIn ? '/employer/jobs' : '/register';
  const billingLink = (tab) => (user?.role === 'employer' ? `/employer/settings/billing?tab=${tab}` : employerLink);
  const planTabs = [
    { key: 'plans', label: '💳 Hiring Plans', count: plans.length },
    { key: 'credits', label: '👤 Candidate Credits', count: creditPacks.length },
    { key: 'boost', label: '⭐ Job Boost', count: jobBoosts.length },
  ].filter((t) => t.count > 0);
  const activeTab = planTabs.some((t) => t.key === planTab) ? planTab : planTabs[0]?.key;
  const sugClass = 'px-4 py-2 text-sm text-gray-700 hover:bg-[#FBEFF4] hover:text-[#C22B5C] cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis';
  const sugBox = 'absolute top-full mt-2 min-w-full w-max max-w-[280px] bg-white rounded-xl shadow-xl border border-gray-100 z-30 max-h-60 overflow-y-auto text-left';

  if (user?.role === 'agent') return null;

  return (
    <div className="home-root min-h-screen bg-white overflow-x-clip text-[#1E0F3D]">
      <style>{`
        .brand-gradient { background-image: linear-gradient(90deg,#7C3AED,#DB2777); }
        .home-root h2 {
          display: inline-block;
          background-image: linear-gradient(90deg,#7C3AED,#DB2777);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          color: transparent;
        }
        .home-root .brand-gradient h2,
        .home-root .animated-gradient h2 {
          background-image: none;
          -webkit-text-fill-color: #fff;
          color: #fff;
        }
        .animated-gradient { background: linear-gradient(90deg,#7C3AED,#DB2777,#7C3AED); background-size: 200% 100%; animation: gradient-shift 8s ease infinite; }
        .marquee-mask { -webkit-mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent); mask-image: linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent); }

        @keyframes marquee-ltr { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        @keyframes gradient-shift { 0%,100% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } }
        @keyframes rise { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: none; } }
        @keyframes swap { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: none; } }
        .marquee-ltr { animation: marquee-ltr 40s linear infinite; }
        .rise { animation: rise .8s cubic-bezier(.2,.8,.2,1) both; }
        .swap { animation: swap .35s ease-out both; }
        .shine-btn { position: relative; overflow: hidden; }
        .shine-btn::after { content: ''; position: absolute; top: 0; left: 0; width: 30%; height: 100%; background: rgba(255,255,255,.3); transform: translateX(-120%) skewX(-20deg); transition: transform .7s ease; pointer-events: none; }
        .shine-btn:hover::after { transform: translateX(420%) skewX(-20deg); }
.reveal { opacity: 0; transform: translateY(32px); transition: opacity .7s cubic-bezier(.2,.8,.2,1), transform .7s cubic-bezier(.2,.8,.2,1); }
.reveal-left { transform: translateX(-56px); }
.reveal-right { transform: translateX(56px); }
.reveal-zoom { transform: scale(.92); }
.reveal-in { opacity: 1; transform: none; }
.tilt { transition: transform .25s ease-out; will-change: transform; }
@keyframes cta-glow { 0% { box-shadow: 0 0 0 0 rgba(219,39,119,.45); } 100% { box-shadow: 0 0 0 18px rgba(219,39,119,0); } }
.cta-glow { animation: cta-glow 2.4s ease-out infinite; }
@keyframes float { 0%,100% { transform: translateY(0) scale(1); } 50% { transform: translateY(-24px) scale(1.06); } }
@keyframes shimmer { to { background-position: 200% center; } }
@keyframes pop-in { from { opacity: 0; transform: scale(.85); } to { opacity: 1; transform: none; } }
@keyframes pulse-ring { 0% { box-shadow: 0 0 0 0 rgba(124,58,237,.45); } 100% { box-shadow: 0 0 0 16px rgba(124,58,237,0); } }
.float-slow { animation: float 9s ease-in-out infinite; }
.float-slower { animation: float 13s ease-in-out infinite reverse; }
.shimmer-text { background-size: 200% auto; animation: shimmer 5s linear infinite; }
.pop-in { animation: pop-in .6s cubic-bezier(.2,.8,.2,1) both; }
.pulse-ring { animation: pulse-ring 2s ease-out infinite; }
.icon-hover { transition: transform .4s ease; }
.group:hover .icon-hover { transform: rotate(-8deg) scale(1.12); }

@keyframes marquee-rtl { from { transform: translateX(-50%); } to { transform: translateX(0); } }
.marquee-rtl { animation: marquee-rtl 45s linear infinite; }
@keyframes bob { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-8px); } }
.bob { animation: bob 3.5s ease-in-out infinite; }
.card-shine::after { content: ''; position: absolute; top: 0; left: 0; width: 40%; height: 100%; background: linear-gradient(100deg, transparent, rgba(255,255,255,.55), transparent); transform: translateX(-150%) skewX(-20deg); transition: transform .8s ease; pointer-events: none; }
.card-shine:hover::after { transform: translateX(350%) skewX(-20deg); }

@keyframes typing-dot { 0%,60%,100% { transform: translateY(0); opacity: .35; } 30% { transform: translateY(-4px); opacity: 1; } }
.typing-dot { width: 6px; height: 6px; border-radius: 9999px; background: #7C3AED; display: inline-block; animation: typing-dot 1.1s ease-in-out infinite; }
.typing-dot:nth-child(2) { animation-delay: .15s; }
.typing-dot:nth-child(3) { animation-delay: .3s; }
@keyframes chip-in { from { opacity: 0; transform: translateY(14px) scale(.9); } to { opacity: 1; transform: none; } }
.chip-in { animation: chip-in .5s cubic-bezier(.2,.8,.2,1) backwards; }
@keyframes assistant-glow {
  0%,100% { box-shadow: 0 0 0 0 rgba(124,58,237,0), 0 40px 80px -30px rgba(124,58,237,.45); }
  50% { box-shadow: 0 0 0 7px rgba(124,58,237,.12), 0 40px 80px -30px rgba(219,39,119,.5); }
}
.assistant-glow { animation: assistant-glow 3.5s ease-in-out infinite; }

/* heading wipe reveal (no color change) */
.reveal h2 { clip-path: inset(-10% 100% -10% 0); transition: clip-path 1s cubic-bezier(.2,.8,.2,1) .15s; }
.reveal-in h2 { clip-path: inset(-10% -2% -10% -2%); }

/* gradient slide on gradient buttons (identical look at rest) */
.shine-btn.brand-gradient {
  background-image: linear-gradient(90deg,#7C3AED,#DB2777,#7C3AED);
  background-size: 200% 100%; background-position: 0 0;
  transition: background-position .5s ease, transform .25s cubic-bezier(.2,.8,.2,1), box-shadow .25s ease;
}
.shine-btn.brand-gradient:hover { background-position: 100% 0; transform: translateY(-2px) scale(1.02); }
.shine-btn:active, .home-root .pb-btn:active { transform: scale(.97); transition-duration: .08s; }

/* animated border on Best Value plan */
@keyframes bv-glow {
  0%,100% { box-shadow: 0 0 0 0 rgba(236,72,153,0), 0 20px 40px -20px rgba(147,51,234,.35); }
  50%     { box-shadow: 0 0 0 5px rgba(236,72,153,.18), 0 20px 40px -20px rgba(236,72,153,.5); }
}
.bv-glow { animation: bv-glow 3s ease-in-out infinite; }

/* only promote tilt cards to their own layer while hovered */
.tilt { will-change: auto; }
.tilt:hover { will-change: transform; }

/* mobile / touch performance */
@media (max-width: 767px) {
  .float-slow, .float-slower, .assistant-glow, .bv-glow { animation: none; }
  .card-shine::after { display: none; }
}
@media (hover: none) { .tilt { transform: none !important; } }

@media (prefers-reduced-motion: reduce) {
  .marquee-ltr, .rise, .swap, .animated-gradient,
  .float-slow, .float-slower, .shimmer-text, .pop-in, .pulse-ring, .cta-glow, .marquee-rtl, .bob, .assistant-glow, .typing-dot, .chip-in { animation: none; }
  .reveal { opacity: 1; transform: none; transition: none; }
  .tilt { transition: none; }
  .shine-btn::after { transition: none; }
}
  /* ---------- industry cards ---------- */
.ind-card { position: relative; display: block; aspect-ratio: 3 / 4; border-radius: 20px; overflow: hidden; isolation: isolate;
  background: linear-gradient(135deg,#F5F0FA,#FDF0F6);
  box-shadow: 0 10px 30px -16px rgba(76,29,149,.4);
  transition: transform .45s cubic-bezier(.2,.8,.2,1), box-shadow .45s ease; }
.ind-card:hover { transform: translateY(-8px); box-shadow: 0 30px 55px -22px rgba(124,58,237,.65); }
.ind-card img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; object-position: top; transition: transform .8s cubic-bezier(.2,.8,.2,1); z-index: 0; }
.ind-card:hover img { transform: scale(1.1); }
.ind-card .ind-shade { position: absolute; inset: 0; z-index: 1; background: linear-gradient(180deg, rgba(20,8,50,0) 30%, rgba(20,8,50,.9) 100%); transition: background .45s ease; }
.ind-card:hover .ind-shade { background: linear-gradient(180deg, rgba(124,58,237,.12) 10%, rgba(76,29,149,.92) 100%); }
.ind-card .ind-sheen { position: absolute; top: 0; left: 0; width: 45%; height: 100%; z-index: 2; pointer-events: none;
  background: linear-gradient(100deg, transparent, rgba(255,255,255,.35), transparent);
  transform: translateX(-160%) skewX(-20deg); transition: transform .9s ease; }
.ind-card:hover .ind-sheen { transform: translateX(380%) skewX(-20deg); }
.ind-card .ind-num { position: absolute; top: 12px; left: 12px; z-index: 3; font-size: 11px; font-weight: 800; color: #fff;
  background: rgba(255,255,255,.2); backdrop-filter: blur(8px); border: 1px solid rgba(255,255,255,.35); padding: 3px 9px; border-radius: 999px; }
.ind-card .ind-arrow { position: absolute; top: 10px; right: 10px; z-index: 3; width: 34px; height: 34px; border-radius: 999px; padding: 8px; color: #fff;
  background: rgba(255,255,255,.2); backdrop-filter: blur(8px); border: 1px solid rgba(255,255,255,.35);
  transition: transform .4s cubic-bezier(.2,.8,.2,1), background .3s ease; }
.ind-card:hover .ind-arrow { transform: rotate(-45deg) scale(1.1); background: linear-gradient(135deg,#7C3AED,#DB2777); border-color: transparent; }
.ind-card .ind-body { position: absolute; left: 0; right: 0; bottom: 0; z-index: 3; padding: 14px; color: #fff; }
.ind-card .ind-title { font-weight: 800; font-size: 14px; line-height: 1.25; }
.ind-card .ind-bar { height: 3px; width: 28px; margin-top: 8px; border-radius: 3px; background: linear-gradient(90deg,#A78BFA,#F472B6); transition: width .5s cubic-bezier(.2,.8,.2,1); }
.ind-card:hover .ind-bar { width: 100%; }
.ind-card .ind-cta { display: inline-flex; align-items: center; gap: 4px; margin-top: 8px; font-size: 12px; font-weight: 700; opacity: .85; transition: opacity .3s, gap .3s; }
.ind-card:hover .ind-cta { opacity: 1; gap: 8px; }

/* pause the whole marquee when the cursor is anywhere on it */
/* pause the whole row when the cursor is on it */
.marquee-mask:hover .marquee-ltr,
.marquee-mask:hover .marquee-rtl { animation-play-state: paused !important; }

/* photo stays completely still: no zoom, no shine */
.ind-card:hover img { transform: none !important; }
.ind-card .ind-sheen { display: none; }

/* card only lifts a little, no scale or tilt */
.ind-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 30px 55px -22px rgba(124,58,237,.65);
}

/* movement only on the text and arrows */
.ind-card .ind-title { transition: transform .4s cubic-bezier(.2,.8,.2,1); }
.ind-card:hover .ind-title { transform: translateY(-4px); }
.ind-card:hover .ind-cta svg { animation: ind-nudge .7s ease-in-out infinite; }
@keyframes ind-nudge { 0%,100% { transform: translateX(0); } 50% { transform: translateX(4px); } }
@media (prefers-reduced-motion: reduce) {
  .ind-card, .ind-card img, .ind-card .ind-sheen, .ind-card .ind-arrow, .ind-card .ind-bar { transition: none; }
}

/* ---------- why cards ---------- */
.why-card { position: relative; overflow: hidden; isolation: isolate; height: 100%; padding: 28px; border-radius: 24px;
  background: #fff; border: 1px solid #EDE4FB; box-shadow: 0 10px 30px -20px rgba(76,29,149,.35);
  transition: transform .45s cubic-bezier(.2,.8,.2,1), box-shadow .45s ease, border-color .3s ease; }
.why-card::before { content: ''; position: absolute; inset: 0; z-index: -1; opacity: 0;
  background: linear-gradient(135deg,#7C3AED,#DB2777); transition: opacity .45s ease; }
.why-card:hover { transform: translateY(-8px); border-color: transparent; box-shadow: 0 30px 55px -22px rgba(124,58,237,.65); }
.why-card:hover::before { opacity: 1; }
.why-card::after { content: ''; position: absolute; top: 0; left: 0; width: 40%; height: 100%; pointer-events: none;
  background: linear-gradient(100deg, transparent, rgba(255,255,255,.3), transparent);
  transform: translateX(-160%) skewX(-20deg); transition: transform .9s ease; }
.why-card:hover::after { transform: translateX(380%) skewX(-20deg); }
.why-num { position: absolute; top: 12px; right: 20px; font-size: 60px; font-weight: 800; line-height: 1; color: rgba(124,58,237,.1);
  transition: color .4s ease, transform .5s cubic-bezier(.2,.8,.2,1); user-select: none; }
.why-card:hover .why-num { color: rgba(255,255,255,.22); transform: scale(1.15) translateY(4px); }
.why-icon { width: 52px; height: 52px; padding: 13px; border-radius: 16px; margin-bottom: 22px; color: #fff;
  background: linear-gradient(135deg,#7C3AED,#DB2777); box-shadow: 0 12px 24px -10px rgba(124,58,237,.6);
  transition: transform .5s cubic-bezier(.2,.8,.2,1), background .3s ease, color .3s ease; }
.why-card:hover .why-icon { transform: rotate(-10deg) scale(1.12); background: #fff; color: #7C3AED; }
.why-title { font-size: 18px; font-weight: 800; color: #1E0F3D; margin-bottom: 8px; transition: color .3s ease; }
.why-body { font-size: 14px; line-height: 1.6; color: #6B7280; transition: color .3s ease; }
.why-card:hover .why-title { color: #fff; }
.why-card:hover .why-body { color: rgba(255,255,255,.9); }
.why-bar { height: 3px; width: 32px; margin-top: 18px; border-radius: 3px; background: linear-gradient(90deg,#A78BFA,#F472B6);
  transition: width .5s cubic-bezier(.2,.8,.2,1), background .3s ease; }
.why-card:hover .why-bar { width: 100%; background: #fff; }
@media (prefers-reduced-motion: reduce) {
  .why-card, .why-card::after, .why-num, .why-icon, .why-bar { transition: none; }
}
/* ---------- why planb (light) ---------- */
.wp-section { position: relative; overflow: hidden; background: #fff; color: #1E0F3D; padding: 96px 24px; isolation: isolate; }
.wp-section::before { content: ''; position: absolute; z-index: -1; width: 560px; height: 560px; top: -200px; left: -160px; border-radius: 50%; background: radial-gradient(circle, rgba(124,58,237,.14), transparent 65%); }
.wp-section::after { content: ''; position: absolute; z-index: -1; width: 520px; height: 520px; bottom: -200px; right: -140px; border-radius: 50%; background: radial-gradient(circle, rgba(219,39,119,.12), transparent 65%); }
.wp-wrap { max-width: 1200px; margin: 0 auto; }
.wp-head { display: grid; gap: 24px; grid-template-columns: 1fr; align-items: end; margin-bottom: 48px; }
@media (min-width: 900px) { .wp-head { grid-template-columns: 1.5fr 1fr; gap: 56px; } }
.home-root .wp-section h2 { font-size: clamp(32px, 5vw, 54px); line-height: 1.08; font-weight: 800; letter-spacing: -0.02em; margin: 0; }
.wp-sub { color: #6B7280; font-size: 16px; line-height: 1.65; margin: 0 0 20px; max-width: 420px; }
.wp-cta { display: inline-flex; align-items: center; gap: 8px; color: #fff; font-weight: 700; font-size: 14px; padding: 13px 24px; border-radius: 12px; background: linear-gradient(90deg,#7C3AED,#DB2777); box-shadow: 0 10px 30px -10px rgba(124,58,237,.6); transition: transform .25s cubic-bezier(.2,.8,.2,1), box-shadow .25s; }
.wp-cta:hover { transform: translateY(-2px); box-shadow: 0 16px 34px -10px rgba(219,39,119,.55); }

.wp-grid { display: grid; gap: 16px; grid-template-columns: 1fr; }
@media (min-width: 900px) {
  .wp-grid { grid-template-columns: repeat(6, 1fr); }
  .wp-a { grid-column: 1 / 4; grid-row: 1 / 3; }
  .wp-b { grid-column: 4 / 7; }
  .wp-c { grid-column: 4 / 7; }
  .wp-d { grid-column: 1 / 4; }
  .wp-e { grid-column: 4 / 7; }
}
.wp-card { position: relative; border-radius: 28px; padding: 28px; border: 1px solid #EDE4FB; background: #fff; box-shadow: 0 14px 40px -24px rgba(76,29,149,.35); display: flex; flex-direction: column; gap: 18px; transition: border-color .3s, transform .4s cubic-bezier(.2,.8,.2,1), box-shadow .4s; }
.wp-card:hover { border-color: rgba(219,39,119,.4); transform: translateY(-4px); box-shadow: 0 28px 50px -24px rgba(124,58,237,.45); }
.wp-a { background: linear-gradient(160deg, #F5EEFF, #FFF1F8 80%); }
.wp-icon { width: 46px; height: 46px; padding: 11px; border-radius: 14px; color: #fff; flex-shrink: 0; background: linear-gradient(135deg,#7C3AED,#DB2777); box-shadow: 0 10px 24px -8px rgba(124,58,237,.55); }
.wp-title { font-size: 20px; font-weight: 800; margin: 0 0 6px; letter-spacing: -0.01em; color: #1E0F3D; }
.wp-body { font-size: 14px; line-height: 1.6; color: #6B7280; margin: 0; max-width: 460px; }
.wp-top { display: flex; gap: 16px; align-items: flex-start; }

.wp-mock { border-radius: 18px; background: #fff; border: 1px solid #EDE4FB; padding: 16px; margin-top: auto; box-shadow: 0 8px 24px -18px rgba(76,29,149,.35); }
.wp-mock-label { font-size: 11px; color: #9CA3AF; margin: 0 0 10px; }
.wp-chips { display: flex; flex-wrap: wrap; gap: 6px; }
.wp-chip { font-size: 12px; font-weight: 600; padding: 6px 12px; border-radius: 999px; color: #7C3AED; background: #F5F0FA; border: 1px solid #E9DDFB; transition: background .25s, color .25s, border-color .25s; }
a.wp-chip:hover { background: linear-gradient(90deg,#7C3AED,#DB2777); color: #fff; border-color: transparent; }
.wp-job { display: grid; grid-template-columns: 1fr auto; gap: 4px 12px; padding: 12px 0; border-top: 1px solid #F1E9FB; }
.wp-job:first-of-type { border-top: 0; }
.wp-job b { font-size: 14px; font-weight: 700; color: #1E0F3D; }
.wp-job small { display: block; font-size: 12px; color: #9CA3AF; font-weight: 400; margin-top: 2px; }
.wp-pct { font-weight: 800; font-size: 15px; color: #DB2777; align-self: center; font-variant-numeric: tabular-nums; }
.wp-bar { grid-column: 1 / 3; height: 6px; border-radius: 6px; background: #F1E9FB; overflow: hidden; }
.wp-bar i { display: block; height: 100%; width: 0; border-radius: 6px; background: linear-gradient(90deg,#7C3AED,#DB2777); transition: width 1.3s cubic-bezier(.2,.8,.2,1); transition-delay: var(--d, 0s); }
.wp-in .wp-bar i { width: var(--w); }

.wp-co { display: flex; align-items: center; gap: 12px; }
.wp-logo { width: 42px; height: 42px; border-radius: 12px; background: linear-gradient(135deg,#7C3AED,#DB2777); color: #fff; font-weight: 800; display: flex; align-items: center; justify-content: center; }
.wp-co b { display: block; font-size: 14px; color: #1E0F3D; }
.wp-co small { font-size: 12px; color: #9CA3AF; }
.wp-verified { margin-left: auto; display: inline-flex; align-items: center; gap: 6px; font-size: 12px; font-weight: 700; color: #059669; background: #ECFDF5; border: 1px solid #A7F3D0; padding: 6px 10px; border-radius: 999px; }

.wp-apply { display: flex; align-items: center; gap: 12px; }
.wp-apply-btn { border: 0; cursor: pointer; font-weight: 700; font-size: 14px; padding: 12px 22px; border-radius: 12px; color: #fff; background: linear-gradient(90deg,#7C3AED,#DB2777); transition: transform .2s, background .3s; }
.wp-apply-btn:hover { transform: translateY(-2px); }
.wp-apply-btn.done { background: #10B981; }
.wp-apply small { color: #6B7280; font-size: 12px; }
.wp-apply-btn:focus-visible, .wp-cta:focus-visible, .wp-chip:focus-visible, .wp-stage:focus-visible { outline: 2px solid #7C3AED; outline-offset: 3px; }

.wp-stages { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-top: auto; }
.wp-stage { display: flex; flex-direction: column; gap: 4px; padding: 12px; border-radius: 14px; background: #FBF5FF; border: 1px solid #EDE4FB; font-size: 13px; font-weight: 700; color: #1E0F3D; transition: background .25s, border-color .25s, transform .25s, color .25s; }
.wp-stage small { font-weight: 400; font-size: 11px; color: #6B7280; transition: color .25s; }
.wp-stage:hover { background: linear-gradient(135deg,#7C3AED,#DB2777); border-color: transparent; color: #fff; transform: translateY(-2px); }
.wp-stage:hover small { color: rgba(255,255,255,.85); }

@media (prefers-reduced-motion: reduce) {
  .wp-bar i { transition: none; width: var(--w); }
  .wp-card, .wp-cta, .wp-stage, .wp-apply-btn { transition: none; }
}
@media (max-width: 640px) { .wp-section { padding: 64px 16px; } .wp-card { padding: 22px; border-radius: 22px; } }


/* ---------- mock interview ---------- */
.mi-section { isolation: isolate; }
.mi-blob { position: absolute; z-index: -1; border-radius: 50%; pointer-events: none; }
.mi-blob-a { width: 420px; height: 420px; top: -40px; left: -140px; background: radial-gradient(circle, rgba(124,58,237,.14), transparent 65%); animation: float 11s ease-in-out infinite; }
.mi-blob-b { width: 380px; height: 380px; bottom: -40px; right: -120px; background: radial-gradient(circle, rgba(219,39,119,.13), transparent 65%); animation: float 14s ease-in-out infinite reverse; }

/* feature rows (stagger in when the left column reveals) */
.mi-feat { display: flex; align-items: center; gap: 14px; padding: 12px 16px; border-radius: 16px; background: #fff; border: 1px solid #EDE4FB;
  box-shadow: 0 8px 24px -18px rgba(76,29,149,.4); opacity: 0; transform: translateX(-18px);
  transition: opacity .6s ease, transform .6s cubic-bezier(.2,.8,.2,1), border-color .3s, box-shadow .3s; transition-delay: calc(var(--i) * 140ms + 350ms); }
.reveal-in .mi-feat { opacity: 1; transform: none; }
.mi-feat:hover { border-color: rgba(219,39,119,.4); box-shadow: 0 16px 30px -16px rgba(124,58,237,.5); }
.mi-feat-icon { width: 36px; height: 36px; padding: 8px; border-radius: 12px; color: #fff; flex-shrink: 0; background: linear-gradient(135deg,#7C3AED,#DB2777); }

/* looping example conversation */
.mi-demo { margin-top: 24px; max-width: 420px; padding: 16px; border-radius: 20px; background: linear-gradient(160deg,#FBF5FF,#FFF1F8); border: 1px solid #EDE4FB; }
.mi-demo-label { font-size: 11px; color: #9CA3AF; margin: 0 0 8px; }
.mi-demo-row { display: grid; margin-top: 8px; min-height: 40px; }
.mi-demo-row > * { grid-area: 1 / 1; }
.mi-bubble { width: fit-content; max-width: 100%; font-size: 13px; padding: 10px 14px; border-radius: 16px 16px 16px 4px; background: #fff; border: 1px solid #EDE4FB; color: #1E0F3D; font-weight: 600; }
.mi-bubble-me { display: flex; gap: 5px; align-items: center; justify-self: end; border-radius: 16px 16px 4px 16px; background: #F5F0FA; }
.mi-score { align-self: center; justify-self: end; font-size: 12px; font-weight: 800; color: #fff; padding: 9px 14px; border-radius: 999px; background: linear-gradient(90deg,#7C3AED,#DB2777); }
@keyframes mi-q { 0%,2% { opacity: 0; transform: translateY(8px); } 8%,94% { opacity: 1; transform: none; } 100% { opacity: 0; } }
@keyframes mi-typing { 0%,18% { opacity: 0; } 24%,46% { opacity: 1; } 52%,100% { opacity: 0; } }
@keyframes mi-score { 0%,54% { opacity: 0; transform: scale(.7); } 62%,94% { opacity: 1; transform: none; } 100% { opacity: 0; } }
.mi-q { animation: mi-q 9s ease-in-out infinite; }
.mi-typing { animation: mi-typing 9s ease-in-out infinite; }
.mi-score { animation: mi-score 9s cubic-bezier(.2,.8,.2,1) infinite; }

/* card with animated gradient border */
.mi-card { border: 0; }
.mi-card::before { content: ''; position: absolute; inset: 0; padding: 2px; border-radius: inherit; pointer-events: none;
  background: linear-gradient(120deg,#7C3AED,#DB2777,#F59E0B,#7C3AED); background-size: 300% 300%; animation: mi-border 6s linear infinite;
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0); -webkit-mask-composite: xor; mask-composite: exclude; }
@keyframes mi-border { 0% { background-position: 0% 50%; } 100% { background-position: 300% 50%; } }

.mi-float { position: absolute; z-index: 5; font-size: 12px; font-weight: 700; padding: 8px 14px; border-radius: 999px; background: #fff; color: #7C3AED;
  border: 1px solid #EDE4FB; box-shadow: 0 14px 30px -12px rgba(124,58,237,.5); animation: bob 4s ease-in-out infinite; }
.mi-f1 { top: -16px; right: 28px; }
.mi-f2 { bottom: -16px; left: 28px; color: #DB2777; animation-delay: -2s; }

/* drop zone */
.mi-drop { border: 2px dashed #D8C8F7; background: #FBF5FF; transition: border-color .25s, background .25s, transform .25s; }
.mi-drop:hover, .mi-drop-on { border-color: #7C3AED; background: #F5EEFF; transform: scale(1.01); }
.mi-drop-done { border-style: solid; border-color: #10B981; background: #ECFDF5; }
.mi-drop-done .mi-drop-icon { background-image: linear-gradient(135deg,#10B981,#059669); }

@media (max-width: 640px) { .mi-float { display: none; } .mi-blob { animation: none; } }
@media (prefers-reduced-motion: reduce) {
  .mi-blob, .mi-card::before, .mi-float, .mi-q, .mi-typing, .mi-score { animation: none; }
  .mi-q, .mi-score { opacity: 1; }
  .mi-typing { display: none; }
  .mi-feat { opacity: 1; transform: none; transition: none; }
}
      `}</style>

      <style>{upgradeCss}</style>

      <ScrollProgress />
<BackToTop />
<StickyCta isLoggedIn={isLoggedIn} />
<Navbar user={user} />

      {/* ================================ HERO ================================ */}

<HeroSection
  keyword={keyword} setKeyword={setKeyword}
  location={location} setLocation={setLocation}
  industry={industry} setIndustry={setIndustry}
  departments={departments}
  onSearch={handleSearch}
  onKeywordChange={handleKeywordChange}
  keywordSuggestions={showKeywordSuggestions ? keywordSuggestions : []}
  onKeywordPick={(s) => { setKeyword(s); setShowKeywordSuggestions(false); }}
  onKeywordBlur={() => setTimeout(() => setShowKeywordSuggestions(false), 150)}
  onLocationChange={handleLocationChange}
  locationSuggestions={showLocationSuggestions ? locationSuggestions : []}
  onLocationPick={(s) => { setLocation(s); setShowLocationSuggestions(false); }}
  onLocationBlur={() => setTimeout(() => setShowLocationSuggestions(false), 150)}
/>

{/* <PlanBAnimatedHero
  employerLink={employerLink}
  assistant={<PathAssistant isLoggedIn={isLoggedIn} />}
/> */}

      

<IndustrySection />


 <CitySection />
<PlanBExplainer />

      
      {/* <CareerStageSection /> */}
        
      {/* <AiRecruitmentSection /> */}
      {/* <EmployerSection employerLink={employerLink} /> */}
      {/* <GuestMockInterview /> */}




      <FaqSection />

      <FinalCta employerLink={employerLink} />

      <Footer />
    </div>
  );
}

export default Home;

